import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
const points = ['Estás por empezar los sólidos y no sabes por dónde comenzar', 'Quieres entender la diferencia entre BLW, papillas y alimentación combinada', 'Te da miedo el atragantamiento y quieres sentirte más preparado/a', 'Quieres introducir alimentos con más tranquilidad y menos presión', 'Buscas una guía práctica, bonita y fácil de seguir', 'Quieres ayudar a tu bebé a crear una relación sana con la comida desde el inicio'];
export function WhoIsThisFor() {
  return <section className="py-24 bg-sand relative" data-id="element-367">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-368">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-369">
          {/* Left: Editorial Image */}
          <motion.div className="relative h-[500px] rounded-2xl overflow-hidden shadow-lg" initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-370">
            <img src="https://cdn.magicpatterns.com/uploads/h2hb5cvC6jxpbxkDifQ47p/04Pa6MEGHOVqcUFu3YGLa.jpg" alt="Bebé comiendo en su silla alta" className="w-full h-full object-cover object-top" data-id="element-371" />
            <div className="absolute inset-0 bg-terracotta/5 mix-blend-multiply" data-id="element-372" />
          </motion.div>

          {/* Right: Content */}
          <div className="space-y-8" data-id="element-373">
            <motion.h2 className="text-4xl lg:text-5xl font-serif text-charcoal" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-374">
              Esta guía es para ti si…
            </motion.h2>

            <div className="space-y-6" data-id="element-375">
              {points.map((point, i) => <motion.div key={i} className="flex items-start gap-4 border-b border-warmGray/20 pb-4 last:border-0" initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} data-id="element-376">
                  <span className="text-terracotta font-serif text-xl italic mt-1 shrink-0" data-id="element-377">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <p className="text-lg text-charcoal" data-id="element-378">{point}</p>
                </motion.div>)}
            </div>

            <motion.a href="https://epikkastore.com/cart/45054208213015:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="bg-olive hover:bg-olive/90 text-white px-8 py-4 rounded-lg font-medium transition-colors shadow-sm w-full sm:w-auto inline-block text-center" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.6
          }} data-id="element-379">
              Comprar ahora
            </motion.a>
          </div>
        </div>
      </div>
    </section>;
}